import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { clientSingleOptionFormatter } from 'components/forms/autocomplete/Client';
import Data from 'components/Data';
import FormSwitchery from 'components/forms/FormSwitchery';
import PaymentReceiverEdit from 'components/modals/PaymentReceiverEdit';

class CreacheckBillingConditions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPaymentReceiverChange: false,
    };
  }

  componentDidUpdate = prevProps => {
    const { paymentReceiverFormStatus } = this.props;

    if (
      prevProps.paymentReceiverFormStatus.pending &&
      !paymentReceiverFormStatus.pending &&
      !paymentReceiverFormStatus.hasError
    ) {
      this.closePaymentReceiverChange();
    }
  };

  closePaymentReceiverChange = () => {
    this.setState({ showPaymentReceiverChange: false });
  };

  render() {
    const {
      intl: { messages },
      entity,
      updateEntity,
      disabled,
      paymentReceiver,
    } = this.props;
    const { showPaymentReceiverChange } = this.state;

    const paymentReceiverValue = (!paymentReceiver.pending &&
      !!paymentReceiver.data &&
      clientSingleOptionFormatter(paymentReceiver.data)) || { value: null, label: messages.unassigned };

    return (
      <>
        <Data dataName="paymentReceiver" url={`/api/whitelabels/${entity.getId()}/paymentreceiver.json`} />

        <div className="panel panel-transparent">
          <div className="panel-body">
            <p>Billing-Conditions</p>
            <div className="form-group-attached">
              <div className="form-group form-group-default padding-10">
                <FormSwitchery
                  label={messages.is_debtor}
                  name="isDebtor"
                  checked={entity.getIsDebtor()}
                  value
                  onChange={updateEntity}
                  disabled={disabled}
                />
              </div>
              <div className="form-group form-group-default padding-10">
                <FormSwitchery
                  label={messages.should_user_pay}
                  name="shouldUserPay"
                  checked={entity.getShouldUserPay()}
                  value
                  onChange={updateEntity}
                  disabled={disabled}
                />
              </div>
              <div className="form-group form-group-default padding-10">
                <FormSwitchery
                  label={messages.receive_payment_from_users}
                  name="receivePaymentFromUsers"
                  checked={entity.getReceivePaymentFromUsers()}
                  value
                  onChange={updateEntity}
                  disabled={disabled}
                />
              </div>
              <div className="form-group form-group-default padding-10">
                <FormSwitchery
                  label={messages.use_payment_receiver}
                  name="usePaymentReceiver"
                  checked={entity.getUsePaymentReceiver()}
                  value
                  onChange={updateEntity}
                  disabled={disabled}
                />
              </div>
              <div class="form-group form-group-default padding-10">
                <label>{messages.payment_receiver}</label>
                <span>
                  {(paymentReceiver.pending && <i className="fa fa-circle-notch fa-spin" />) ||
                    paymentReceiverValue.label}
                </span>
                <Button
                  class="m-l-10 btn-rounded"
                  bsSize="xs"
                  onClick={() => this.setState({ showPaymentReceiverChange: true })}
                >
                  {messages.edit}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <PaymentReceiverEdit
          show={showPaymentReceiverChange}
          whiteLabelId={entity.getId()}
          close={this.closePaymentReceiverChange}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    paymentReceiver: state.data.paymentReceiver,
    paymentReceiverFormStatus: state.formStatus.paymentReceiverEdit,
  };
};

export default injectIntl(connect(mapStateToProps)(CreacheckBillingConditions));
